
import { useContext } from "react";

import Loader from "../components/loader";
import { AccountContext } from "../context/account";

import { Button } from "@mui/material";
import "leaflet/dist/leaflet.css";
import styles from "../../src/styles/pages/404.module.scss";
import ErrorPageIcon from "../assets/error-page-icon.svg";
import GhostIcon from "../assets/ghost.svg";
import { Img } from "../components/image";
import { Meta } from "../components/meta";
import { LoginPageWrapper } from "../components/mui-login-page-wrapper";
import { isBrowser } from "../helpers/common";

interface NotFoundPageProps {
  default?: boolean;
}

export const NotFoundPage = ({}: NotFoundPageProps) => {
  const { account } = useContext(AccountContext);

  if (!account.checked) {
    <Loader />;
  }

  if (!isBrowser()) {
    return null;
  }

  return (
    <LoginPageWrapper title="Page not found" error={[]} onSubmit={() => {}}>
      <>
        <Meta title="Page not found on MetOceanAtlas" />
        <div className={styles.wrapper} style={{margin: "16px auto 8px"}}>
          <Img src={ErrorPageIcon} alt='404 error' width={40} />
          <Img className={styles.ghost} src={GhostIcon} alt='404 error ghost' width={40} />
        </div>
        
        <p>
          This is a 404 error. The requested URL was not found on this server.
        </p>
        <Button href="/" variant="contained">Go to dashboard</Button>
      </>
    </LoginPageWrapper>
  );
};

export const Head: any = () => <title>Page not found</title>;
